import { render, staticRenderFns } from "./activity-loader.vue?vue&type=template&id=25efea1b"
import script from "./activity-loader.vue?vue&type=script&lang=js"
export * from "./activity-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports